// Calendar dates follow the same local timezone as the history timestamps on screen.
// Construct the following midnight, rather than adding 24 hours, to include DST days.
export function historyDateRange(from: string, to: string): { from?: string; to?: string; error?: string } {
  function midnight(value: string) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value)) return null;
    const [year, month, day] = value.split('-').map(Number) as [number, number, number];
    const date = new Date(0); date.setFullYear(year, month - 1, day); date.setHours(0, 0, 0, 0);
    return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
  }
  const start = from ? midnight(from) : null, end = to ? midnight(to) : null;
  if ((from && !start) || (to && !end)) return { error: 'Enter a valid start and end date.' };
  if (start && end && start > end) return { error: 'The end date must be on or after the start date.' };
  if (end) end.setDate(end.getDate() + 1);
  return { ...(start ? { from: start.toISOString() } : {}), ...(end ? { to: end.toISOString() } : {}) };
}
